var Mn = require('backbone.marionette'),
    scope = require('scope');
    $ = require('jquery');

module.exports = Mn.View.extend({
    behaviors: [
        require('site/behaviors/Carousel'),
        require('site/behaviors/Collapse'),
        require('site/behaviors/Mask'),
        require('site/behaviors/Menu'),
        require('site/behaviors/Modals'),
        require('site/behaviors/Newsletter'),
        require('site/behaviors/Video'),
    ],
    regions: {
        'content': '#content',
        'modals': '#modals'
    },
    currentOpenedSubmenu: null,
    initialize: function(){
        var self = this;
        
        this.listenTo(scope.app, 'change:sections', this.sections);
    },
    regex: /section-(.*)/i,
    sections: function (sections) {
        for (var section in sections) {
            var macth = section.match(this.regex);
            if (macth) {
                this.$el.find('[data-change-section="' + macth[1] + '"]').html(sections[section]);
                if(macth[1] == 'menu') {
                    $('.menu__nav__list')
                        .on('focusout')
                        .on('mouseleave', function(e){
                            var target = $(e.currentTarget);
                            target.removeClass('active');
                    });
                }
            }
        }

        var title = this.$el.find('[data-page-title]').attr('data-page-title');
        $('title').text(title);
    }
});



//////////////////
// WEBPACK FOOTER
// ./resources/assets/site/scripts/views/Layout.js
// module id = 224
// module chunks = 3